<template>
  <div>
    <div class="card">
      <div class="bg-blue-light p-1">
        <TitleButton
            btnTitle="Add New Client"
            :showExtraBtn="true"
            :showBtn="false"
            :showAddNew="true"
            :extraBtnTitle="'Register'"
            title="Client List"
            @onClickAddNewButton="onClickAddNewButton"
            @onClickExtraBtn="onClickRegisterBtn"
        />
      </div>

      <div class="my-2 px-2">
        <div class="row">
          <div class="col-12 col-md-3">
            <label class="col-form-label">BDO</label>
            <AsyncSelect
                placeholder="Select BDO name"
                v-model="saleRepresentative"
                :api-service="fetchAllSR"
            />
          </div>
          <div class="col-12 col-md-3">
            <label class="col-form-label">Select Bank</label>
            <AsyncSelect
                placeholder="Select Bank"
                v-model="singleBank"
                :api-service="fetchContactProfiles"
                :additional-query="{ type: 'dealer'}"
            />
          </div>
          <div class="col-12 col-md-3">
            <label class="col-form-label">Bank-Branch</label>
            <AsyncSelect
                v-model="singleDealer"
                placeholder="Select Bank-Branch"
                :api-service="fetchAllDealers"
                :additional-query="dealerQuery"
                :key="dealerRenderKey"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <div class="d-flex align-items-center justify-content-between filter-label">
              <label for="colFormLabel" class="col-form-label">Client: </label>
              <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
            </div>
            <AsyncSelect
                placeholder="Select Client"
                v-model="contactProfile"
                :api-service="fetchContactProfiles"
                :additional-query="additionalContactOption"
                :format-label="formatPatientLabel"
                :additional-option="additionalOption"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label class="form-label new-customer">Sale Representative</label>
            <AsyncSelect
                placeholder="Select Sale Representative"
                v-model="contactOwner"
                :api-service="fetchContactProfiles"
                :additional-query="{ with_mobile: 1, roles: 'contact_owner,sales_representative' }"
                :format-label="formatPatientLabel"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label">Select District</label>
            <AsyncSelect
                placeholder="Select District"
                v-model="district"
                :additional-query="{ type: 'district'}"
                :api-service="fetchAreaList"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
            <label class="form-label">Select Location</label>
            <AsyncSelect
                placeholder="Select Location"
                v-model="area"
                :api-service="fetchAreaList"
            />
          </div>
          <div class="col-2 mt-2">
            <button
                style="min-width: 64px;"
                @click="getContactsList"
                class="btn btn-primary btn-block waves-effect waves-float waves-light"
            >Go
            </button>
          </div>
        </div>

        <div class="col-12">
          <div class="d-flex justify-content-end px-2">
            <button
                @click="exportList"
                class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
            >
              Export
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 px-2 my-2">
        <div class="card card-height">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th>Photo</th>
                <th class="nowrap">Client ID</th>
                <th class="nowrap">Client Name</th>
                <th class="nowrap">Bank-Branch</th>
                <th class="nowrap">Location</th>
                <th class="nowrap">BDO Name</th>
                <th class="nowrap">Sale Representative</th>
                <th class="nowrap">Registration Date</th>
                <th class="nowrap">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, i) in contacts" :key="i">
                <td><img :src="item.photo" alt="Generic placeholder image" class="w-44"/></td>
                <td>{{ item.serial_no }}</td>
                <td>{{ item.full_name }}</td>
                <td>{{ item.dealer_name }}</td>
                <td>{{ item.area_name }}</td>
                <td>{{ item.bdo_name }}</td>
                <td>{{ item.contact_owner_name }}</td>
                <td>{{ item.registration_date }}</td>
                <td>
                  <button class="btn btn-primary btn-sm"
                          @click="goToSaleRegister(item)"
                          style="cursor: pointer"
                  >
                    <i class="fas fa-eye"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <p v-if="!contacts.length" class="text-center mt-5">No data</p>
          </div>
        </div>

      </div>

      <ContactDropdownFilter
          v-if="$store.state.isModalOpenThree"
          @onSearchContact="onSearchContact"
          :companyRoles="companyRoles"
          :isFilterable="true"
      />

      <AddContactModal
          v-if="$store.state.isModalOpenFour"
          modalStateKey="isModalOpenFour"
          contactType="organization"
          :companyRoles="companyRoles"
      />

      <div class="px-2 position-absolute bottom-0">
        <Pagination
            :offset="offset"
            @onPageChange="onPageChange"
            ref="pagination"
        />
      </div>
    </div>
    <Loader v-if="loading"/>
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue';
import {useRoute, useRouter} from "vue-router";
import {computed, inject, onMounted, ref, watch} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import Pagination from "@/components/atom/Pagination.vue";
import {useStore} from "vuex";
import handleRole from "@/services/modules/role";
import handleCompanyContact from "@/services/modules/companyContact";
import handleDepartments from "@/services/modules/procurement/organization-settings/department";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleCrm from '@/services/modules/crm/crm.js'
import handleContact from '@/services/modules/contact';
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import AddContactModal from '@/components/atom/Contact/AddContactModal.vue'

const $route = useRoute();
const $router = useRouter();
const $store = useStore();

const showError = inject('showError');
const showSuccess = inject('showSuccess');
const { fetchClientRegister } = handleCompanyContact();
const { fetchAllDealers, fetchAllSR, fetchAreaList } = handleCrm();
const { fetchContactProfiles } = handleContact();
const {fetchCompanyDefaultRoles} = handleRole();
const { fetchDepartmentList } = handleDepartments()
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchHome } = handleChartAccount()
import handleChartAccount from '@/services/modules/chartAccount'
const singleDealer = ref(null);
const singleBank = ref(null);
const saleRepresentative = ref(null);
const offset = ref(10);
const loading = ref(false);
const contactProfile = ref('');
const contactOwner = ref(null);
const contacts = ref([])
const companyRules = ref([])
const searchTerm = ref('');
const companyRoles = ref([]);
const additionalContactOption = ref({
  with_mobile: 1,
  dealer_id: ''
});
const additionalOption = ref([]);
const area = ref(null);
const district = ref(null);

// computed
const start = computed(() => $route.query.start);
const end = computed(() => $route.query.end);
const page = computed(() => $route.query.page);
const companyId = computed(() => $route.params.companyId);
const token = localStorage.getItem('token');

const dealerQuery = ref({
  sale_representative_id: '',
  contact_profile_id: ''
});
const dealerRenderKey = ref(0);

const onSearchContact = (contact) => {
  contactProfile.value = contact
}
const onOpenContactSearchModal = () => {
  $store.state.isModalOpenThree = true;
}
//methods
const setPaginationData = (data) => {
  $store.commit('setPaginationData', data)
};
const resetPagination = () => {
  $store.commit('resetPagination')
};

const goToSaleRegister = (item) => {
  let param = {
    companyId: $route.params.companyId,
    moduleId: $route.params.moduleId,
    menuId: $route.params.menuId,
    pageId: $route.params.pageId
  }

  let query = $route.query;
  query.clientRegisterId = item.id;

  $router.push({
    name:  'service-sales-register',
    params: param,
    query: query
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, $route.query)
  routeQuery.page = page
  await $router.push({path: $route.path, query: routeQuery})
  await getContactsList()
}
const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onClickAddNewButton = () => {
  $store.state.isModalOpenFour = true;
}

const onClickRegisterBtn = () => {
  $router.push({name: 'contact-register', params: $route.params, query: $route.query})
}

const getQuery = () => {
  let query = '?company_id=' + companyId.value
  query += '&offset=' + offset.value
  query += '&company_roles=customer'
  if (page) query += '&page=' + page.value
  if (saleRepresentative.value) query += '&sale_representative_id=' + saleRepresentative.value.id
  if (singleBank.value) query += '&bank_id=' + singleBank.value.id
  if (singleDealer.value) query += '&dealer_id=' + singleDealer.value.id
  if (contactProfile.value) query += '&contact_profile_id=' + contactProfile.value.id
  if (contactOwner.value) query += '&contact_owner_id=' + contactOwner.value.id
  if (area.value) query += '&area_id=' + area.value.id
  if (district.value) query += '&district_id=' + district.value.id
  return query
};

async function getContactsList() {
  try {
    const res = await fetchClientRegister(getQuery());
    if (!res.status) {
      contacts.value = [];
      return resetPagination()
    }
    contacts.value = res.data.data;
    await setPagination(res.data)
  } catch (err) {
    if (err.response) {
      showError(err.response.message)
    }
  }
}

const exportList = () => {
  let url = `${process.env.VUE_APP_BASE_URL}/api/company/contacts/client-register${getQuery()}&_token=${token}&is_export=1`;
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.click();
}

watch(() => singleBank.value, (newValue, oldValue) => {
  singleDealer.value = null;
  dealerQuery.value.contact_profile_id = '';
  dealerRenderKey.value += 1;

  if(newValue) {
    dealerQuery.value.contact_profile_id = newValue.id;
  }

})

const getCompanyRoles = async () => {
  const res = await fetchCompanyDefaultRoles(`?company_id=${$route.params.companyId}&roles=customer`);
  if (res.status) {
    companyRoles.value = res.data
  }
}

onMounted(() => {
  loading.value = true;
  const companyQuery = `?company_id=${companyId.value}`
  const rolesRes = fetchCompanyDefaultRoles(companyQuery)
  Promise.all([
    rolesRes.then(res => {
      if (res.data) companyRules.value = res.data
    }),
    fetchHome().then(res => {

    }),
    getContactsList(),
    getCompanyRoles()
  ]).then(() => {
    loading.value = false
  }).catch((err) => {
    loading.value = false
  })

})
</script>

<style scoped>
.card--height {
  min-height: 200px
}
.nowrap {
  white-space: nowrap;
}
</style>